import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash';
import Table from '../../../common/table/Table';
import Const from '../Const';
import { includes } from 'lodash';
import {
  REDUCER_NAME,
  loadMoreOverviewTable,
  fetchListDataTable,
} from './../reducer';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
  formatValue,
  formatPercent,
} from './../../../../component/helpers/Text';
import {
  getColorPrice,
  getColorRedGreen,
} from './../../../../component/helpers/Color';
import { getDataFollowKeyByDot } from './../../../../component/helpers/Common';
import { isTicker } from '../../../helpers/Common';
import { compose } from 'redux';
import { withComponentId } from './../../../common/ComponentIdContext';
import TimeZoneHandle from '../../../common/timezone-handle';

class TablePriceData extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      page: 1,
      pageSize: 60,
      tabTitle: props.title,
      schemaKey: props.schemaKey,
      timeRangeFilter: props.timeRangeFilter,
    };
    this.state = this.initialState;
    this.tableRef = React.createRef();
  }

  componentWillReceiveProps(nextProps) {
    const { id, fetchListDataTable, timeRangeFilter, indexSumary } = this.props;
    if (
      nextProps.schemaKey !== this.state.schemaKey &&
      nextProps.title !== this.state.tabTitle
    ) {
      this.resetScroll();
      this.setState(
        {
          ...this.state,
          page: 1,
          tabTitle: nextProps.title,
          schemaKey: nextProps.schemaKey,
        },
        () => fetchListDataTable(id),
      );
    }
    if (
      nextProps.timeRangeFilter !== timeRangeFilter ||
      nextProps.indexSumary.organCode !== indexSumary.organCode
    ) {
      this.resetScroll();
      this.setState({ ...this.state, page: 1 });
    }
  }

  resetScroll = () => {
    this.tableRef.current.scrollToTop();
  };

  getClassName = item => {
    const { indexSumary, timeRangeFilter } = this.props;
    if (timeRangeFilter !== 'Daily') {
      const change = get(item, Const.priceDataTableOverview.CHANGE);
      if (change === 0) {
        return 'text-s-color-4';
      }

      return change > 0 ? 'text-s-color-5' : 'text-s-color-3';
    }
    if (!isTicker(indexSumary)) {
      return getColorPrice(
        getDataFollowKeyByDot(item, Const.priceDataTableOverview.LAST),
        getDataFollowKeyByDot(item, Const.colorChangeAndPercenChange.REF_PRICE),
        99999,
        0,
        'text',
      );
    }

    return getColorPrice(
      getDataFollowKeyByDot(item, Const.priceDataTableOverview.LAST),
      getDataFollowKeyByDot(item, Const.colorChangeAndPercenChange.REF_PRICE),
      getDataFollowKeyByDot(
        item,
        Const.colorChangeAndPercenChange.CEILING_PRICE,
      ),
      getDataFollowKeyByDot(item, Const.colorChangeAndPercenChange.FLOOR_PRICE),
      'text',
    );
  };

  getDataFromRedux = id => {
    return state =>
      state[REDUCER_NAME].listMultiComponent[id].listPriceDataById;
  };

  handleScroll = e => {
    const { totalPage, currenPageScroll } = this.props;

    const bottom = e.target.scrollHeight - Math.ceil(e.target.scrollTop);
    if (currenPageScroll < totalPage) {
      if (e.target.clientHeight >= bottom) {
        this.loadmoreActive(totalPage);
      }
    }
  };

  loadmoreActive = totalPage => {
    const { id, isFetching, currentSearch, loadMoreOverviewTable } = this.props;
    const { code } = currentSearch;

    if (isFetching) return;
    this.setState(
      prevState => {
        return {
          page:
            prevState.page === totalPage
              ? prevState.page
              : (prevState.page += 1),
        };
      },
      () => {
        const { page, pageSize } = this.state;
        loadMoreOverviewTable(
          { Code: code, Page: page, PageSize: pageSize },
          id,
        );
      },
    );
  };

  formatDateByTimeRangeFilter = (text, timeRangeFilter) => {
    let formatText = text;
    if (timeRangeFilter === Const.listTimeRangeByKey.Monthly.key) {
      //return formatMonthAndYear(formatText);
      return <TimeZoneHandle time={formatText} format="MM/YYYY" />;
    }
    if (timeRangeFilter === Const.listTimeRangeByKey.Yearly.key) {
      //return formatYear(formatText);
      return <TimeZoneHandle time={formatText} format="YYYY" />;
    }
    //return formatDate(formatText);
    return <TimeZoneHandle time={formatText} format="MM/DD/YYYY" />;
  };

  getSchema = (schemaKey, tabTitle) => {
    const ZERO_VALUE = 0;
    const { indexSumary } = this.props;
    return Object.keys(schemaKey).map(item => {
      const key = schemaKey[item];
      const title = `${tabTitle}.${item}`;
      const result = {
        key,
        title,
      };

      if (
        includes(
          [Const.priceDataTableOverview.LAST, Const.priceDataTableForeign.LAST],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: text => {
            return isTicker(indexSumary)
              ? formatTextFloat(formatPrice(text))
              : formatTextFloat(text);
          },
        };
      }

      if (
        includes(
          [
            Const.priceDataTableOverview.HIGH,
            Const.priceDataTableOverview.LOW,
            Const.priceDataTableOverview.OPEN,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: text => {
            if (!isTicker(indexSumary)) {
              return <span>{formatTextFloat(text)}</span>;
            }
            return formatTextFloat(formatPrice(text));
          },
        };
      }

      if (
        includes(
          [
            Const.priceDataTableOrderStatistic.VOLUMN_BUY_ORDER,
            Const.priceDataTableOrderStatistic.VOLUMN_SELL_ORDER,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: text => {
            if (text === ZERO_VALUE) {
              return <span>{'--'}</span>;
            }
            return formatTextFloat(formatPrice(text));
          },
        };
      }

      if (
        includes(
          [
            Const.priceDataTableOrderStatistic.NR_OF_BUY_ORDER,
            Const.priceDataTableOrderStatistic.NR_OF_SELL_ORDER,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: text => {
            if (text === ZERO_VALUE) {
              return <span>{'--'}</span>;
            }
            return formatTextFloat(text, 0);
          },
        };
      }

      if (includes([Const.priceDataTableOverview.AVERAGE_PRICE], key)) {
        return {
          ...result,
          disableSort: true,
          render: text => {
            return formatTextFloat(formatPrice(text));
          },
        };
      }

      if (includes([Const.priceDataTableOverview.CHANGE], key)) {
        return {
          ...result,
          disableSort: true,
          render: (text, item) => {
            const className = this.getClassName(item);
            return (
              <span className={`${className} font-weight-bold`}>
                {formatTextFloat(
                  isTicker(indexSumary) ? formatPrice(text) : text,
                )}
              </span>
            );
          },
        };
      }

      if (includes([Const.priceDataTableOverview.PERCENT_PRICE_CHANGE], key)) {
        return {
          ...result,
          disableSort: true,
          render: (text, item) => {
            const className = this.getClassName(item);
            return (
              <span className={`${className} font-weight-bold`}>
                {formatTextFloat(formatPercent(text))}%
              </span>
            );
          },
        };
      }

      if (includes([Const.priceDataTableForeign.OWNED_RATIO], key)) {
        return {
          ...result,
          disableSort: true,
          render: (text, item) => {
            const ownerRatio = getDataFollowKeyByDot(
              item,
              'foreignerPercentage',
            );
            if (+ownerRatio === 0) {
              return 0;
            }

            return <span>{formatTextFloat(formatPercent(ownerRatio))}</span>;
          },
        };
      }

      if (
        includes(
          [
            Const.priceDataTableOverview.MATCHED_VOLUME,
            Const.priceDataTableOverview.PUT_THROUGH_VOL,
            Const.priceDataTableOverview.TOTAL_VOL,
            Const.priceDataTableForeign.BUY_ORDER_VOL,
            Const.priceDataTableForeign.SELL_ORDER_VOL,
            Const.priceDataTableProprietary.BUY_VOL,
            Const.priceDataTableProprietary.SELL_VOL,
            Const.priceDataTableOrderStatistic.BUY_VOL,
            Const.priceDataTableOrderStatistic.SELL_VOL,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: text => {
            if (text === ZERO_VALUE) {
              return <span>{'--'}</span>;
            }
            return formatTextFloat(formatVolume(text));
          },
        };
      }

      if (
        includes(
          [
            Const.priceDataTableOverview.MATCHED_VALUE,
            Const.priceDataTableOverview.PUT_THROUGH_VALUE,
            Const.priceDataTableOverview.TOTAL_VALUE,
            Const.priceDataTableForeign.BUY_ORDER_VALUE,
            Const.priceDataTableForeign.SELL_ORDER_VALUE,
            Const.priceDataTableProprietary.BUY_VALUE,
            Const.priceDataTableProprietary.SELL_VALUE,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: text => {
            if (text === ZERO_VALUE) {
              return <span>{'--'}</span>;
            }
            return formatTextFloat(formatValue(text));
          },
        };
      }

      if (includes([Const.priceDataTableOverview.DATE], key)) {
        return {
          ...result,
          disableSort: true,
          render: (text, item) => {
            const { timeRangeFilter } = this.props;
            let date = this.formatDateByTimeRangeFilter(text, timeRangeFilter);
            return item.rateAdjusted > 0 ? (
              <div className="font-weight-light">
                {date}
                {` *`}
              </div>
            ) : (
              <div className="font-weight-light">{date}</div>
            );
          },
        };
      }

      if (Const.priceDataTableForeign.FOREIGN_ROOM === key) {
        return {
          ...result,
          disableSort: true,
          render: value => {
            if (value === ZERO_VALUE) {
              return <span>{'--'}</span>;
            }
            return formatTextFloat(formatVolume(value));
          },
        };
      }

      if (
        includes(
          [
            Const.priceDataTableOrderStatistic.NET_VOL,
            Const.priceDataTableForeign.NET_VOLUME,
            Const.priceDataTableProprietary.NET_VOL,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: text => {
            const className = getColorRedGreen(text, 'text');
            if (text === ZERO_VALUE || !text) {
              return <span>{'--'}</span>;
            }
            return (
              <span className={className}>
                {formatTextFloat(formatVolume(text))}
              </span>
            );
          },
        };
      }

      if (
        includes(
          [
            Const.priceDataTableForeign.NET_VALUE,
            Const.priceDataTableProprietary.NET_VALUE,
          ],
          key,
        )
      ) {
        return {
          ...result,
          disableSort: true,
          render: text => {
            const className = getColorRedGreen(text, 'text');
            if (text === ZERO_VALUE || !text) {
              return <span>{'--'}</span>;
            }
            return (
              <span className={className}>
                {formatTextFloat(formatValue(text))}
              </span>
            );
          },
        };
      }

      return {
        ...result,
        disableSort: true,
        render: text => text,
      };
    });
  };

  render() {
    const {
      componentId,
      isFetching,
      hideColumns,
      isLoading,
      listPriceDataId,
    } = this.props;
    const { schemaKey, tabTitle } = this.state;

    return (
      <Table
        thValign="top"
        scrollRef={this.tableRef}
        ids={listPriceDataId}
        resizable={true}
        columnDraggable={false}
        rowDraggable={false}
        getDataFromRedux={this.getDataFromRedux(componentId)}
        hideColumns={hideColumns}
        onScrollFunction={this.handleScroll}
        isLoading={isLoading ? isLoading : isFetching}
        schema={this.getSchema(schemaKey, tabTitle)}
      />
    );
  }
}

const mapStateToProps = (state, { componentId }) => {
  return {
    listPriceDataId:
      state[REDUCER_NAME].listMultiComponent[componentId].listPriceDataId,
    totalPage: state[REDUCER_NAME].listMultiComponent[componentId].totalPage,
    isFetching: state[REDUCER_NAME].listMultiComponent[componentId].isFetching,
    currentSearch:
      state[REDUCER_NAME].listMultiComponent[componentId].currentSearch,
    currenPageScroll:
      state[REDUCER_NAME].listMultiComponent[componentId].currenPageScroll,
    indexSumary:
      state[REDUCER_NAME].listMultiComponent[componentId].indexSumary,
    timeRangeFilter:
      state[REDUCER_NAME].listMultiComponent[componentId].timeRangeFilter,
    isLoading: state[REDUCER_NAME].listMultiComponent[componentId].isLoading,
  };
};

const mapDispatchToProps = {
  loadMoreOverviewTable,
  fetchListDataTable,
};

export default compose(
  withComponentId,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TablePriceData);
